import { Link } from 'react-router-dom';
import type { ReactElement } from 'react';

export type SourcePoRequestFields = {
  sourcePurchaseOrderId?: string | null;
  sourcePurchaseOrderNumber?: string | null;
  sourceProcurementRequestId?: string | null;
  sourceRequestNumber?: string | null;
};

/**
 * Shown for inventory that came from a paid purchase order (procurement request).
 */
export function SourcePoRequestLinks(props: SourcePoRequestFields): ReactElement | null {
  const poId = (props.sourcePurchaseOrderId ?? '').trim();
  const prId = (props.sourceProcurementRequestId ?? '').trim();
  if (!poId && !prId) {
    return null;
  }
  return (
    <p className="hint" style={{ marginTop: '0.35rem' }}>
      {!!poId && (
        <Link to={`/purchase-orders/${encodeURIComponent(poId)}`}>
          PO {props.sourcePurchaseOrderNumber?.trim() || '—'}
        </Link>
      )}
      {!!prId && (
        <>
          {!!poId ? ' · ' : ''}
          <Link to={`/requests/${encodeURIComponent(prId)}`}>
            Request {props.sourceRequestNumber?.trim() || '—'}
          </Link>
        </>
      )}
    </p>
  );
}
